//@flow

type State = {
  +mainTitle: string,
  +subTitle: string,
};

type Payload = {
  mainTitle: string,
  subTitle: string,
  canBack: boolean,
};

export default {
  state: { mainTitle: '', subTitle: '', canBack: false },
  reducers: {
    changePageTitle: (state: State, payload: Payload) => {
      return Object.assign({}, state, {
        mainTitle: payload.mainTitle,
        subTitle: payload.subTitle,
        canBack: payload.canBack,
      });
    },
  },
};
